export default {
  data(){
    return{
      title:''
    }
  },
  created(){
    this.title = this.$route.meta.title
  }
}